import layout from '@/layout'
// import { _l } from '@/i18n'
const meta = { auth: true, cache: true, head: { back: true } }

export default {
  path: '/base',
  component: layout,
  meta: {
    funcID: 'E0001',
    PID: 'E00',
  },
  children: ((pre) => [
    {
      path: 'awsspu',
      name: `${pre}awsspu`,
      meta: {
        ...meta,
        head: { back: false },
        funcID: 'E000109',
        PID: 'E00',
      },
      component: () => import('@/views/ecom/base/awsspu'),
    },
    {
      path: 'awsspu/:pageType/:amzSpuCode?',
      name: `${pre}awsspu-detail`,
      meta: {
        ...meta,
        title: ({ $route }) => {
          const { amzSpuNo = '新增' } = $route.query || {}
          return `Amazon SPU${amzSpuNo ? ' | ' : ''}${amzSpuNo || ''}`
        },
        funcID: 'E000109',
        PID: 'E00',
        pageConfig: { layout: { class: 'bg-transparent p-0', bodyClass: 'p-0' } },
      },
      component: () => import('@/views/ecom/base/awsspu/detail'),
    },
    {
      path: 'awsspuReview',
      name: `${pre}awsspuReview`,
      meta: {
        ...meta,
        cache: true,
        head: { back: false },
        funcID: 'E000112',
        PID: 'E00',
      },
      component: () => import('@/views/ecom/base/awsspuReview'),
    },
    {
      path: 'awsGoods',
      name: `${pre}awsGoods`,
      meta: {
        ...meta,
        head: { back: false },
        funcID: 'E000103',
        PID: 'E00',
      },
      component: () => import('@/views/ecom/base/awsGoods'),
    },
    {
      path: 'awsGoods/:pageType/:amzSkuCode?',
      name: `${pre}awsGoods-detail`,
      meta: {
        ...meta,
        title: ({ $route }) => {
          const { amzSkuNo = '' } = $route.query || {}
          return amzSkuNo || 'Amazon电商产品'
        },
        funcID: 'E000103',
        PID: 'E00',
        pageConfig: { layout: { class: 'bg-transparent p-0', bodyClass: 'p-0' } },
      },
      component: () => import('@/views/ecom/base/awsGoods/detail'),
    },
    {
      path: 'awsGoodsReview',
      name: `${pre}awsGoodsReview`,
      meta: {
        ...meta,
        head: { back: false },
        funcID: 'E000113',
        PID: 'E00',
      },
      component: () => import('@/views/ecom/base/awsGoodsReview'),
    },
    {
      path: 'awsListing',
      name: `${pre}awsListing`,
      meta: {
        ...meta,
        head: { back: false },
        funcID: 'E000107',
        PID: 'E00',
      },
      component: () => import('@/views/ecom/base/awsListing'),
    },
    {
      path: 'awsMoqSet',
      name: `${pre}awsMoqSet`,
      meta: {
        ...meta,
        head: { back: false },
        funcID: 'E000108',
        PID: 'E00',
      },
      component: () => import('@/views/ecom/base/awsMoqSet'),
    },
    {
      path: 'awsMoqSet/:pageType/:code?',
      name: `${pre}awsMoqSet-detail`,
      meta: {
        ...meta,
        title: ({ $route }) => {
          const { amzMoqNo = '' } = $route.query || {}
          return amzMoqNo || 'Amazon产品起定量'
        },
        funcID: 'E000108',
        PID: 'E00',
        pageConfig: { layout: { class: 'bg-transparent p-0', bodyClass: 'p-0 m-0' } },
      },
      component: () => import('@/views/ecom/base/awsMoqSet/detail'),
    },
    {
      path: 'awsStore',
      name: `${pre}awsStore`,
      meta: {
        ...meta,
        head: { back: false },
        funcID: 'E000104',
        PID: 'E00',
      },
      component: () => import('@/views/ecom/base/awsStore'),
    },
    {
      path: 'awsStore/:pageType/:code?',
      name: `${pre}awsStore-detail`,
      meta: {
        ...meta,
        title: ({ $route }) => {
          const { amzStoreNo = '' } = $route.query || {}
          return amzStoreNo || 'Amazon店铺'
        },
        funcID: 'E000104',
        PID: 'E00',
        pageConfig: { layout: { class: 'bg-transparent p-0', bodyClass: 'p-0 m-0' } },
      },
      component: () => import('@/views/ecom/base/awsStore/detail'),
    },
    {
      path: 'awsMarket',
      name: `${pre}awsMarket`,
      meta: {
        ...meta,
        head: { back: false },
        funcID: 'E000116',
        PID: 'E00',
      },
      component: () => import('@/views/ecom/base/awsMarket'),
    },
    {
      path: 'evgspu',
      name: `${pre}evgspu`,
      meta: {
        ...meta,
        head: { back: false },
        funcID: 'E000110',
        PID: 'E00',
      },
      component: () => import('@/views/ecom/base/evgspu'),
    },
    {
      path: 'evgspu/:pageType/:evgSpuCode?',
      name: `${pre}evgspu-detail`,
      meta: {
        ...meta,
        cache: false,
        title: ({ $route }) => {
          const { evgSpuNo = '新增' } = $route.query || {}
          return `Evergrace SPU${evgSpuNo ? ' | ' : ''}${evgSpuNo || ''}`
        },
        funcID: 'E000110',
        PID: 'E00',
        pageConfig: { layout: { class: 'bg-transparent p-0', bodyClass: 'p-0' } },
      },
      component: () => import('@/views/ecom/base/evgspu/detail'),
    },
    {
      path: 'evgspuReview',
      name: `${pre}evgspuReview`,
      meta: {
        ...meta,
        cache: true,
        head: { back: false },
        funcID: 'E000114',
        PID: 'E00',
      },
      component: () => import('@/views/ecom/base/evgspuReview'),
    },
    {
      path: 'evgGoods',
      name: `${pre}evgGoods`,
      meta: {
        ...meta,
        head: { back: false },
        funcID: 'E000101',
        PID: 'E00',
      },
      component: () => import('@/views/ecom/base/evgGoods'),
    },
    {
      path: 'evgGoods/:pageType/:evgSkuCode?',
      name: `${pre}evgGoods-detail`,
      meta: {
        ...meta,
        title: ({ $route }) => {
          const { evgSkuNo = '' } = $route.query || {}
          return evgSkuNo || 'EVG电商产品'
        },
        funcID: 'E000101',
        PID: 'E00',
        pageConfig: { layout: { class: 'bg-transparent p-0', bodyClass: 'p-0' } },
      },
      component: () => import('@/views/ecom/base/evgGoods/detail'),
    },
    {
      path: 'evgGoodsReview',
      name: `${pre}evgGoodsReview`,
      meta: {
        ...meta,
        cache: true,
        head: { back: false },
        funcID: 'E000115',
        PID: 'E00',
      },
      component: () => import('@/views/ecom/base/evgGoodsReview'),
    },
    {
      path: 'evgListing',
      name: `${pre}evgListing`,
      meta: {
        ...meta,
        head: { back: false },
        funcID: 'E000111',
        PID: 'E00',
      },
      component: () => import('@/views/ecom/base/evgListing'),
    },
    {
      path: 'evgSalesPlatform',
      name: `${pre}evgSalesPlatform`,
      meta: {
        ...meta,
        head: { back: false },
        funcID: 'E000102',
        PID: 'E00',
      },
      component: () => import('@/views/ecom/base/evgSalesPlatform'),
    },
    {
      path: 'evgSalesPlatformReview',
      name: `${pre}evgSalesPlatformReview`,
      meta: {
        ...meta,
        head: { back: false },
        funcID: 'E001101',
        PID: 'E00',
      },
      component: () => import('@/views/ecom/base/evgSalesPlatformReview'),
    },
    // {
    //   path: 'evgSalesPlatform/:pageType/:code?',
    //   name: `${pre}evgSalesPlatform-detail`,
    //   meta: {
    //     ...meta,
    //     title: ({ $route }) => {
    //       const { platformNo = '' } = $route.query || {}
    //       if (platformNo) {
    //         return `EVG销售渠道 | ${platformNo}`
    //       }
    //       return `EVG销售渠道`
    //     },
    //     funcID: 'E000102',
    //     PID: 'E00',
    //     pageConfig: { layout: { class: 'bg-transparent p-0', bodyClass: 'p-0' } },
    //   },
    //   component: () => import('@/views/ecom/base/evgSalesPlatform/detail'),
    // },
    {
      path: 'warehouse',
      name: `${pre}warehouse`,
      meta: {
        ...meta,
        head: { back: false },
        funcID: 'E000105',
        PID: 'E00',
      },
      component: () => import('@/views/ecom/base/warehouse'),
    },
    {
      path: 'warehouse/:pageType/:code?',
      name: `${pre}warehouse-detail`,
      meta: {
        ...meta,
        title: ({ $route }) => {
          const { ecomWarehouseNo = '' } = $route.query || {}
          if (ecomWarehouseNo) {
            return `电商仓库维护 | ${ecomWarehouseNo}`
          } else {
            return '电商仓库维护'
          }
        },
        funcID: 'E000105',
        PID: 'E00',
      },
      component: () => import('@/views/ecom/base/warehouse/detail'),
    },
    {
      path: 'salesCompany',
      name: `${pre}salesCompany`,
      meta: {
        ...meta,
        head: { back: false },
        funcID: 'E000106',
        PID: 'E00',
      },
      component: () => import('@/views/ecom/base/salesCompany'),
    },
    {
      path: 'salesCompany/:pageType/:code?',
      name: `${pre}salesCompany-detail`,
      meta: {
        ...meta,
        title: ({ $route }) => {
          const { ecomCompanyNo = '' } = $route.query || {}
          return ecomCompanyNo || '销售公司维护'
        },
        funcID: 'E000106',
        PID: 'E00',
        pageConfig: { layout: { class: 'bg-transparent p-0', bodyClass: 'p-0' } },
      },
      component: () => import('@/views/ecom/base/salesCompany/detail'),
    },
    {
      path: 'hxSpu',
      name: `${pre}hxSpu`,
      meta: {
        ...meta,
        head: { back: false },
        funcID: 'E000117',
        PID: 'E00',
      },
      component: () => import('@/views/ecom/base/hxSpu'),
    },
    {
      path: 'hxSpu/:pageType/:hxSpuCode?',
      name: `${pre}hxSpu-detail`,
      meta: {
        ...meta,
        title: ({ $route }) => {
          const { hxSpuNo = '新增' } = $route.query || {}
          return `Hx SPU${hxSpuNo ? ' | ' : ''}${hxSpuNo || ''}`
        },
        funcID: 'E000117',
        PID: 'E00',
        pageConfig: { layout: { class: 'bg-transparent p-0', bodyClass: 'p-0' } },
      },
      component: () => import('@/views/ecom/base/hxSpu/detail'),
    },
    {
      path: 'hxGoods',
      name: `${pre}hxGoods`,
      meta: {
        ...meta,
        head: { back: false },
        funcID: 'E000118',
        PID: 'E00',
      },
      component: () => import('@/views/ecom/base/hxGoods'),
    },
    {
      path: 'hxGoods/:pageType/:hxSkuCode?',
      name: `${pre}hxGoods-detail`,
      meta: {
        ...meta,
        title: ({ $route }) => {
          const { hxSkuNo = '' } = $route.query || {}
          return hxSkuNo || 'EVG电商产品'
        },
        funcID: 'E000118',
        PID: 'E00',
        pageConfig: { layout: { class: 'bg-transparent p-0', bodyClass: 'p-0' } },
      },
      component: () => import('@/views/ecom/base/hxGoods/detail'),
    },
    {

      path: 'hxListing',
      name: `${pre}hxListing`,
      meta: {
        ...meta,
        head: { back: false },
        funcID: 'E000119',
        PID: 'E00',
      },
      component: () => import('@/views/ecom/base/hxListing'),
    },
    {
      path: 'hxSalesPlatform',
      name: `${pre}hxSalesPlatform`,
      meta: {
        ...meta,
        head: { back: false },
        funcID: 'E000120',
        PID: 'E00',
      },
      component: () => import('@/views/ecom/base/hxSalesPlatform'),
    },
    {
      path: 'hxSalesPlatform/:pageType/:code?',
      name: `${pre}hxSalesPlatform-detail`,
      meta: {
        ...meta,
        title: ({ $route }) => {
          const { platformNo = '' } = $route.query || {}
          if (platformNo) {
            return `合祥销售渠道 | ${platformNo}`
          }
          return `合祥销售渠道`
        },
        funcID: 'E000120',
        PID: 'E00',
        pageConfig: { layout: { class: 'bg-transparent p-0', bodyClass: 'p-0' } },
      },
      component: () => import('@/views/ecom/base/hxSalesPlatform/detail'),
    },
    {
      path: 'awsGoodsOrderReview',
      name: `${pre}awsGoodsOrderReview`,
      meta: {
        ...meta,
        head: { back: false },
        funcID: 'E000121',
        PID: 'E00',
      },
      component: () => import('@/views/ecom/base/awsGoodsOrderReview'),
    },
    {
      path: 'evgNcCoding',
      name: `${pre}evgNcCoding`,
      meta: {
        ...meta,
        head: { back: false },
        funcID: 'E000122',
        PID: 'E00',
      },
      component: () => import('@/views/ecom/base/evgNcCoding'),
    },
    {
      path: 'amzPriceControlParams',
      name: `${pre}amzPriceControlParams`,
      meta: {
        ...meta,
        head: { back: false },
        funcID: 'E000123',
        PID: 'E00',
      },
      component: () => import('@/views/ecom/base/amzPriceControlParams'),
    },
    {
      path: 'amzPriceControl',
      name: `${pre}amzPriceControl`,
      meta: {
        ...meta,
        head: { back: false },
        funcID: 'E000124',
        PID: 'E00',
      },
      component: () => import('@/views/ecom/base/amzPriceControl'),
    },
    {
      path: 'amzPriceControl/:pageType/:amzPriceControlCode?',
      name: `${pre}amzPriceControl-detail`,
      meta: {
        ...meta,
        title: ({ $route }) => {
          const { amzPriceControlNo = '' } = $route.query || {}
          return `Amazon控价表 | ${amzPriceControlNo || 'New'}`
        },
        funcID: 'E000124',
        PID: 'E00',
        pageConfig: { layout: { class: 'bg-transparent p-0', bodyClass: 'p-0' } },
      },
      component: () => import('@/views/ecom/base/amzPriceControl/detail'),
    },
    {
      path: 'evgGoodsCombine',
      name: `${pre}evgGoodsCombine`,
      meta: {
        ...meta,
        head: { back: false },
        funcID: 'E001102',
        PID: 'E00',
      },
      component: () => import('@/views/ecom/base/evgGoodsCombine'),
    },
    {
      path: 'evgGoodsCombine/:pageType/:evgCombineCode?',
      name: `${pre}evgGoodsCombine-detail`,
      meta: {
        ...meta,
        title: ({ $route }) => {
          const { evgCombineNo = '' } = $route.query || {}
          return `EVG组合产品 | ${evgCombineNo || 'New'}`
        },
        funcID: 'E001102',
        PID: 'E00',
        pageConfig: { layout: { class: 'bg-transparent p-0', bodyClass: 'p-0' } },
      },
      component: () => import('@/views/ecom/base/evgGoodsCombine/detail'),
    },
    {
      path: 'evgOsWhGoods',
      name: `${pre}evgOsWhGoods`,
      meta: {
        ...meta,
        head: { back: false },
        funcID: 'E001103',
        PID: 'E00',
      },
      component: () => import('@/views/ecom/base/evgOsWhGoods'),
    },
  ])('ecom-base-'),
}
